import { IEnquiry } from '@wot/typings';
import { parseISO } from 'date-fns';
import { format } from 'date-fns/esm';
import Chip from '../../../../components/Chip';
import { TableRowItemData } from '../../../../components/Table';

export default function TableRowItem({ enquiry }: { enquiry: IEnquiry }) {
  return (
    <>
      <TableRowItemData text={format(parseISO(enquiry.createdAt), 'dd/MM/yyyy')} />
      <TableRowItemData text={enquiry._id} />
      <TableRowItemData text={enquiry.name} />
      <TableRowItemData text={enquiry.subject} />
      <TableRowItemData text={enquiry.email} />
      <TableRowItemData
        component={
          <Chip state={enquiry.status === 'active' ? 'warning' : enquiry.status === 'resolved' ? 'success' : 'pending'}>
            <p className="text-sm font-semibold capitalize">{enquiry.status}</p>
          </Chip>
        }
      />
    </>
  );
}
